import { Input } from 'antd';
import LOCALS from 'commons/locals';
import i18n from 'i18n';
import { Control, Controller } from 'react-hook-form';
import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';
import { FormLabel } from '../../form-label';

type ProductRemarkFieldName =
  | 'colorRemark'
  | 'materialRemark'
  | 'hardwareRemark'
  | 'stampRemark';

const ProductRemark = ({
  control,
  index,
  name,
  label,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
  name: ProductRemarkFieldName;
  label: string;
}) => {
  return (
    <div className="flex items-center gap-2">
      <FormLabel>{label}:</FormLabel>
      <Controller
        name={`productList.${index}.${name}`}
        control={control}
        render={({ field }) => (
          <Input.TextArea
            {...field}
            className="w-full"
            autoSize={{ minRows: 1, maxRows: 3 }}
            placeholder={i18n.t(LOCALS.please_enter) || ''}
          />
        )}
      />
    </div>
  );
};

export default ProductRemark;
